import React from "react";
import { useTranslate } from "hooks/translation-hooks";
import { useAppointmentConfirmation } from "../../hooks/useAppointmentConfirmation";
import {
  DetailsPanel,
  InlineParagraph,
  TextArea,
  PrimaryButton
} from "../../CardsStyled";
import { useSelector } from "react-redux";
import { currentNotificationSelector } from "redux/selectors/currentNotification";

export const ShowComments = () => {
  const t = useTranslate();
  const { jobReference, missionOrderId } = useSelector(
    currentNotificationSelector
  );
  const {
    moreInformation: comment,
    updateMoreInfo,
    confirmCurrentAppointment
  } = useAppointmentConfirmation({
    jobReference,
    missionOrderId
  });

  return (
    <>
      <DetailsPanel>
        <InlineParagraph>{t("appointment_reschedule-text_1")}</InlineParagraph>
        <TextArea
          data-testid="appointment_reschedule-information"
          placeholder={t("appointment_reschedule-placeholder")}
          onInput={updateMoreInfo}
          defaultValue={comment}
          maxLength={1024}
        />
      </DetailsPanel>
      <DetailsPanel>
        <PrimaryButton
          disabled={comment === ""}
          data-action="accept_button-click"
          data-testid="accept_button-click"
          onClick={confirmCurrentAppointment}
        >
          {t("appointment_reschedule-send_comment_button")}
        </PrimaryButton>
      </DetailsPanel>
    </>
  );
};

export default ShowComments;
